import React, { useState } from 'react';
import { observer } from 'mobx-react';
import Tooltip from '@mui/material/Tooltip';
import withStyles from '@mui/styles/withStyles';
import { useTranslation, Trans } from 'react-i18next';
const { REACT_APP_STATIC_PREFIX = '/static' } = import.meta.env;
import { resourcePath } from '../../../utils/helpers';
import { Heading1 } from '../../design-system/headings';
import './interactive-img.scss';
import PresentationHeading from './presentation-heading';

// customizing styling of Tooltip
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
        fontStyle: 'italic',
        padding: '1em',
    },
}))(Tooltip);

export const InteractiveImg = observer(({ ui }) => {
    const { t } = useTranslation('assessment');
    const [open, setOpen] = useState(false);
    const [openedHint, setOpenedHint] = useState(null);

    const openTooltip = (key) => {
        setOpen(true);
        setOpenedHint(key);
    };

    const closeTooltip = () => {
        setOpen(false);
        setOpenedHint(null);
    };

    return (
        <div className="assessment-presentation">
            <div className="question">
                <PresentationHeading ui={ui} />
                <div
                    className="hoverable-image"
                    style={{
                        backgroundImage: `url(${resourcePath(ui.image)})`,
                    }}
                >
                    {ui.hoverPoints.map((point, i) => (
                        <LightTooltip
                            style={{
                                top: point.top,
                                left: point.left,
                                position: 'absolute',
                            }}
                            title={`“${t(point.text)}”`}
                            placement="bottom-start"
                            onMouseEnter={() => openTooltip(i)}
                            onClick={() => openTooltip(i)}
                            onMouseLeave={closeTooltip}
                            onClose={closeTooltip}
                            open={open && openedHint === i}
                            key={i}
                        >
                            <img
                                src={`${REACT_APP_STATIC_PREFIX}/img/assessment/orange-dot.svg`}
                                alt="tooltip"
                            />
                        </LightTooltip>
                    ))}
                </div>
            </div>
        </div>
    );
});
